/**
 * 用于移动端会议测引导的逻辑
 *
 */

import { onMounted } from '@vue/composition-api';
import _ from 'lodash';
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
import userGuideInfoHandler from '@/renderer/views/composition/common/userGuideInfoHandler';
const mobileGuideHandler = () => {
  const { hasGuidance, hasSurveyInfo } = userGuideInfoHandler();
  const methods = {
    async init() {
      const { isMobile, editionFlag } = store.getters;
      // 个人版不主动弹留资窗口
      if (editionFlag === 'personal') return;
      // 非移动端直接return
      if (!isMobile) return;
      const [hasGuidanceFlag, hasSurveyInfoFlag] = await Promise.all([hasGuidance(), hasSurveyInfo()]);
      if (!hasGuidanceFlag) {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.START_MOBILE_GUIDE);
        return;
      }
      if (!hasSurveyInfoFlag) {
        // 没有留资，需要用户留资
        ipc.emit(ipc.RENDERER_EVENTS_MAP.START_MOBILE_USER_SURVEY);
      }
    },
  };
  onMounted(() => {
    methods.init();
  });
};
export default mobileGuideHandler;
